import QuantityStepper from './QuantityStepper';

export default QuantityStepper;
